/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import update from 'immutability-helper';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { IProductDetail, IReceiverPart } from '../../../models/product-detail';
import SelectInput from '../../inputs/select-input';
import TextInput from '../../inputs/text-input';

interface IReceiverSelect {
    productState: IProductDetail;
    receivers: IReceiverPart[];
    receiver: IReceiverPart | null;
    maxQuantity: number;
    updateReceivers: (receivers: IReceiverPart[]) => void;
}

const ReceiverSelect = ({
    productState,
    receivers,
    receiver,
    maxQuantity,
    updateReceivers,
}: IReceiverSelect) => {
    const intl = useIntl();
    const addReceiver = () => {
        updateReceivers(
            update(receivers, {
                $push: [
                    {
                        ...receiver!,
                        quantity: 1,
                    },
                ],
            })
        );
    };

    const deleteReceiver = (index: number) => {
        if (receivers.length === 1) {
            updateReceivers(
                update(receivers, {
                    [index]: {
                        side: { $set: '' },
                        cableLength: { $set: 0 },
                        gain: { $set: '' },
                        quantity: { $set: 0 },
                    },
                })
            );
        } else {
            updateReceivers(update(receivers, { $splice: [[index, 1]] }));
        }
    };

    const updateReceiver = (event: any, index: number) => {
        switch (event.target.name) {
            case 'GainSelection':
                updateReceivers(
                    update(receivers, {
                        [index]: { gain: { $set: event.target.value } },
                    })
                );
                break;
            case 'EarSelection':
                updateReceivers(
                    update(receivers, {
                        [index]: { side: { $set: event.target.value } },
                    })
                );
                break;
            case 'CableLengthSelection':
                updateReceivers(
                    update(receivers, {
                        [index]: { cableLength: { $set: event.target.value } },
                    })
                );
                break;
            case 'noOfReceivers': {
                let val = event.target.value;
                if (val > maxQuantity) {
                    val = maxQuantity;
                }
                updateReceivers(
                    update(receivers, {
                        [index]: {
                            quantity: { $set: parseInt(val) },
                        },
                    })
                );
                break;
            }
            default:
                break;
        }
    };

    return (
        <div>
            {receivers.map((receiver, index) => {
                return (
                    <div key={index}>
                        <div className="row" style={{ paddingBottom: '10px' }}>
                            <div className="col-sm-3">
                                <SelectInput
                                    name="EarSelection"
                                    onChange={(event: any) =>
                                        updateReceiver(event, index)
                                    }
                                    value={receiver.side}
                                    label="Ear"
                                    options={[
                                        {
                                            value: 'L',
                                            text: intl.formatMessage({
                                                id: 'Left',
                                            }),
                                        },
                                        {
                                            value: 'R',
                                            text: intl.formatMessage({
                                                id: 'Right',
                                            }),
                                        },
                                    ]}
                                    hasDefaultOption={true}
                                    defaultOption={'Select Ear'}
                                    labelClassName="col-sm-12"
                                    fieldClassName="col-sm-12"
                                    inlineStyle={{
                                        backgroundColor: '#f4f4f4',
                                        height: '40px',
                                        borderRadius: '0',
                                    }}
                                />
                            </div>
                            <div className="col-sm-3">
                                <SelectInput
                                    name="CableLengthSelection"
                                    onChange={(event: any) =>
                                        updateReceiver(event, index)
                                    }
                                    value={receiver.cableLength}
                                    label="Cable Length"
                                    options={productState.options
                                        .find((x) => x.id === 8)!
                                        .items.map((cableLength) => ({
                                            value: cableLength.name,
                                            text: cableLength.name,
                                        }))}
                                    hasDefaultOption={true}
                                    defaultOption={'Select Cable Length'}
                                    labelClassName="col-sm-12"
                                    fieldClassName="col-sm-12"
                                    inlineStyle={{
                                        backgroundColor: '#f4f4f4',
                                        height: '40px',
                                        borderRadius: '0',
                                    }}
                                />
                            </div>
                            {productState.options.find((x) => x.id === 19) && (
                                <div className="col-sm-3">
                                    <SelectInput
                                        name="GainSelection"
                                        onChange={(event: any) =>
                                            updateReceiver(event, index)
                                        }
                                        value={receiver.gain}
                                        label={'Gain'}
                                        options={productState.options
                                            .find((x) => x.id === 19)!
                                            .items.map((gain) => ({
                                                value: gain.english
                                                    ? gain.english
                                                    : gain.name,
                                                text: intl.formatMessage({
                                                    id: gain.name,
                                                    defaultMessage: gain.name,
                                                }),
                                            }))}
                                        hasDefaultOption={true}
                                        defaultOption={'Select Gain'}
                                        labelClassName="col-sm-12"
                                        fieldClassName="col-sm-12"
                                        inlineStyle={{
                                            backgroundColor: '#f4f4f4',
                                            height: '40px',
                                            borderRadius: '0',
                                        }}
                                    />
                                </div>
                            )}
                            <div className="col-sm-3">
                                <TextInput
                                    name="noOfReceivers"
                                    onChange={(event: any) =>
                                        updateReceiver(event, index)
                                    }
                                    value={receiver.quantity}
                                    title={
                                        'Quantity cannot exceed ' +
                                        maxQuantity.toString()
                                    }
                                    label={'Quantity'}
                                    labelClassName="col-sm-12"
                                    fieldClassName="col-sm-6"
                                    elementClassName="pdp-input-text"
                                />
                                <div className=" col-sm-1">
                                    <a
                                        onClick={() => deleteReceiver(index)}
                                        className="far fa-window-close close-button"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
            <div className="row">
                <div className="col-md-12 col-sm-12">
                    <h5>
                        <a onClick={addReceiver}>
                            <FormattedMessage id="Add_Another" />
                        </a>
                    </h5>
                </div>
            </div>
        </div>
    );
};

export default ReceiverSelect;
